const { layoutStyles, colorPallette } = require('./themeConfig');

module.exports = {
  colorPallette,
  layoutStyles,
};
